import axios from "axios";

// Variables
export const CURRENT_APP_VERSION = "1.3";

export const backendUrl = "https://api.e2ecrm.in/"; // VPS backend
export const mediaBackendUrl = "https://api.e2ecrm.in";



// export const backendUrl = "https://localhost:3000/"; 
// export const mediaBackendUrl = "https://localhost:3000";

// Axios instance
export const api = axios.create({
  baseURL: backendUrl,
});

// Interceptor (token attach)
api.interceptors.request.use(async (config) => {
  config.url = config.url || "";

  const token = localStorage.getItem("jwtToken"); // React JS la AsyncStorage instead localStorage
  if (token) config.headers.Authorization = `Bearer ${token}`;

  return config;
});

// Pad 0 function
function az(value) {
  return value < 10 ? "0" + value : value;
}

// Local Date,Time,Ticket Number generator
export function localDateTimeTkGen(value) {
  const nfdt = new Date();
  const dt = az(nfdt.getDate());
  const mt = az(nfdt.getMonth() + 1);
  const yr = nfdt.getFullYear();
  const fdt = `${dt}/${mt}/${yr}`;
  const hrs24 = nfdt.getHours();
  const hrs = hrs24 % 12 || 12;
  const mnt = az(nfdt.getMinutes());
  const scs = az(nfdt.getSeconds());
  const period = hrs24 >= 12 ? "PM" : "AM";

  const ftim = `${hrs}:${mnt}:${scs} ${period}`;
  const tktgn = `${mt}${dt}${yr}${hrs24}${mnt}${scs}`;

  return value === "ticket"
    ? tktgn
    : value === "time"
    ? ftim
    : value === "date"
    ? fdt
    : "No Arguments Provided";
}

// Date/Time format function
export function getFormattedDateOrTime(dateString, type) {
  const dateObj = new Date(dateString);

  if (type === "date") {
    const day = dateObj.getDate().toString().padStart(2, "0");
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  } else if (type === "time") {
    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");
    const amPm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${amPm}`;
  } else {
    throw new Error("Invalid type. Use 'date' or 'time'.");
  }
}

// Dial number – Web la tel: link open panna
export function dialNumber(number) {
  window.open(`tel:${number}`, "_self");
}

// Capitalize Each Word
export function capitalizeEachWord(str) {
  if (typeof str !== "string") return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
